import { useUserContext } from "./use-user-context";

export function useSystemHelper() {
	const { systems } = useUserContext();

	/**
	 *
	 * @description To use you need to be inside of the userContext
	 * @param system
	 * @returns Systems commmonName if its not defined it returns a empty string
	 */
	const getSystemName = (system: string) => {
		return systems.find((s) => s.name === system)?.commonName ?? "";
	};

	const getSystem = (system: string) => {
		return systems.find((s) => s.name === system) ?? null;
	};

	return { getSystemName, getSystem };
}
